import { produce } from 'immer';
export const produceNext = (base, recipe) => {
  const next = produce(base, draft => recipe(draft));
  return next != null && next !== base ? next : undefined;
};